import React, { useEffect, useMemo, useState } from "react";
import { Box } from "@material-ui/core";
import { BrandsWithObjectTypeUrl } from "../../../constants/apiUrls.js";
import appFetch from "../../../api/appFetch.js";
import MultiSelectChipsDropdown from "./MultiSelectChipsDropdown.js";

const MultiBrandsDropdown = ({
  resources,
  brandIds = [],
  objectType,
  brands = [],
  onBrandsChange,
  onRequestStart,
  onRequestEnd,
  containerClass,
  id = "multi-brands-dropdown",
  label = null
}) => {
  const hasBrands = brands && brands.length > 0;
  const [fetchedBrands, setFetchedBrands] = useState([]);

  useEffect(() => {
    if (hasBrands) return;

    if (onRequestStart) onRequestStart();

    // appFetch has no abort support, so guard setState instead - otherwise a
    // response arriving after unmount sets state on a dead component. onRequestEnd
    // must still fire: callers use it to re-enable save buttons.
    let cancelled = false;

    appFetch({
      url: BrandsWithObjectTypeUrl(objectType),
      onSuccess: (response) => {
        if (!cancelled) setFetchedBrands(response);
      },
      onError: () => { },
      onFinalize: () => {
        if (onRequestEnd) onRequestEnd();
      }
    });

    return () => { cancelled = true; };
  }, [hasBrands, objectType]);

  const options = useMemo(() => {
    const source = hasBrands ? brands : fetchedBrands;

    return [...source]
      .sort((a, b) => (a.description > b.description) ? 1 : -1)
      .map(x => ({ key: x.id, name: x.description }));
  }, [hasBrands, brands, fetchedBrands]);

  return (
    <Box className={containerClass} padding="0">
      <MultiSelectChipsDropdown
        id={id}
        label={label ?? resources["Brands"]}
        options={options}
        value={brandIds}
        onChange={onBrandsChange}
      />
    </Box>
  );
};

export default MultiBrandsDropdown;
